export default {
    src:'https://connect.facebook.net/en_US/sdk.js',
    script_id:'facebook-jssdk',
    appId      : '1226621827538755',
    xfbml      : true,
    cookie     : true,
    version    : 'v16.0',
    scope      : 'public_profile,email'
}

